import { Controller } from "@hotwired/stimulus";
import Choices from "choices.js";

// Connects to data-controller="choices"
export default class extends Controller {
  static values = {
    defaultPlaceholder: { type: String, default: "Select an option" },
    selectText: { type: String, default: "Press to select" },
    sort: { type: Boolean, default: true },
    addChoices: { type: Boolean, default: false },
  };

  connect() {
    const hasBlankOption = Array.from(
      this.element.querySelectorAll("option"),
    ).some((option) => option.value === "");

    const options = {
      allowHTML: true,
      itemSelectText: this.selectTextValue,
      shouldSort: this.sortValue,

      // If blank option present, allow it to be selected by enabling the remove item button
      removeItemButton: hasBlankOption,
    };

    // Set default placeholder unless select contains a blank option
    if (!hasBlankOption) {
      options.placeholderValue = this.defaultPlaceholderValue;
    }

    // Allow adding new choices dynamically (for tagging-style selects)
    if (this.addChoicesValue) {
      options.addChoices = true;
      options.addItems = true;
      options.removeItemButton = true;
      options.duplicateItemsAllowed = false;
      options.placeholderValue = "Type to add";
      options.noChoicesText = "Type to add a new item";
      options.noResultsText = "No results found. Press Enter to add.";
      options.addItemText = (value) => `Press Enter to add <b>"${value}"</b>`;
    }

    this.choicesInstance = new Choices(this.element, options);
  }

  setValue(value) {
    this.choicesInstance.setChoiceByValue(value);
  }
}
